import {
  GENRE_OPTIONS,
  DAY_OPTIONS,
  AFFILIATION_OPTIONS,
  HAIR_COLOR_OPTIONS,
  EYE_COLOR_OPTIONS,
  HAIR_LENGTH_OPTIONS,
  ACCESSORY_OPTIONS,
  VOICE_PITCH_OPTIONS,
  VOICE_CHARACTER_OPTIONS,
  GAME_GENRE_OPTIONS,
  TALK_STYLE_OPTIONS,
  PERSONALITY_OPTIONS,
  STREAM_TIME_OPTIONS,
  STREAM_FREQUENCY_OPTIONS,
  LANGUAGE_OPTIONS,
  MODEL_OPTIONS,
  SUBSCRIBER_OPTIONS,
} from "./mockVtubers";

export const FILTER_GROUPS = [
  {
    key: "basic",
    title: "基本情報",
    filters: [
      {
        key: "affiliation",
        label: "個人勢 / 企業勢",
        options: AFFILIATION_OPTIONS,
      },
      { key: "language", label: "メイン言語", options: LANGUAGE_OPTIONS },
      { key: "model", label: "モデル形式", options: MODEL_OPTIONS },
    ],
  },
  //配信スタイルが難しいので一回閉じておく
  {
    key: "streamStyle",
    title: "配信スタイル",
    filters: [
      { key: "genre", label: "配信ジャンル", options: GENRE_OPTIONS },
      { key: "day", label: "配信曜日", options: DAY_OPTIONS },
      // {
      //   key: "streamStyle",
      //   label: "配信スタイル",
      //   options: STREAM_STYLE_OPTIONS,
      // },
      { key: "streamTime", label: "配信時間帯", options: STREAM_TIME_OPTIONS },
      {
        key: "streamFrequency",
        label: "配信頻度",
        options: STREAM_FREQUENCY_OPTIONS,
      },
    ],
  },
  {
    key: "appearance",
    title: "見た目",
    filters: [
      { key: "hairColor", label: "髪色", options: HAIR_COLOR_OPTIONS },
      { key: "eyeColor", label: "瞳の色", options: EYE_COLOR_OPTIONS },
      { key: "hairLength", label: "髪の長さ", options: HAIR_LENGTH_OPTIONS },
      { key: "accessory", label: "アクセサリー", options: ACCESSORY_OPTIONS },
    ],
  },
  {
    key: "voice",
    title: "声",
    filters: [
      { key: "voicePitch", label: "声の高さ", options: VOICE_PITCH_OPTIONS },
      {
        key: "voiceCharacter",
        label: "声の特徴",
        options: VOICE_CHARACTER_OPTIONS,
      },
    ],
  },
  {
    key: "game",
    title: "ゲーム",
    filters: [
      {
        key: "gameGenre",
        label: "ゲームジャンル",
        options: GAME_GENRE_OPTIONS,
      },
    ],
  },
  {
    key: "personality",
    title: "トーク・性格",
    filters: [
      { key: "talkStyle", label: "雑談スタイル", options: TALK_STYLE_OPTIONS },
      { key: "personality", label: "性格", options: PERSONALITY_OPTIONS },
    ],
  },
  {
    key: "subscriber",
    title: "登録者規模",
    filters: [
      { key: "subscriber", label: "登録者レンジ", options: SUBSCRIBER_OPTIONS },
    ],
  },
];

export const FILTER_REV = Object.fromEntries(
  FILTER_GROUPS.flatMap((group) =>
    group.filters.flatMap((filter) =>
      filter.options.map((option) => [
        option.value,
        {
          key: filter.key,
          groupKey: group.key,
        },
      ])
    )
  )
);
